/**
 * Splits CSV text into rows of cells. Quoted cells may hold commas, line breaks and doubled quotes.
 * Blank lines stay in as rows, so a row's index matches its row number in a spreadsheet.
 */
export const parseCsv = (text: string): string[][] => {
  const rows: string[][] = [];
  let row: string[] = [];
  let cell = '';
  let isQuoted = false;

  for (let index = 0; index < text.length; index++) {
    const char = text[index];

    if (isQuoted) {
      if (char === '"' && text[index + 1] === '"') {
        cell += '"';
        index++;
      } else if (char === '"') {
        isQuoted = false;
      } else {
        cell += char;
      }
    } else if (char === '"' && cell === '') {
      isQuoted = true;
    } else if (char === ',') {
      row.push(cell);
      cell = '';
    } else if (char === '\r' || char === '\n') {
      row.push(cell);
      rows.push(row);
      row = [];
      cell = '';

      if (char === '\r' && text[index + 1] === '\n') {
        index++;
      }
    } else {
      cell += char;
    }
  }

  if (cell !== '' || row.length > 0) {
    row.push(cell);
    rows.push(row);
  }

  return rows;
};

const formatCsvCell = (cell: string) => (/[",\r\n]/.test(cell) ? `"${cell.replace(/"/g, '""')}"` : cell);

export const stringifyCsv = (rows: readonly (readonly string[])[]) =>
  rows.map((row) => row.map(formatCsvCell).join(',')).join('\r\n');
